import {
  Box,
  Button,
  ComboboxItem,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDmMasterOrg } from "../../../model/TblDMBranch";
import { tblDmTransportsModel } from "../../../model/TblDmTransportsModel";
import {
  getCommuneSelect,
  getMasterOrgAll,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";

const ChangeLocationV2 = ({
  id,
  province,
  commune,
  addr,
  branchId,
  deleteViewStatus,
  deliveryStatus,
  typeAddr,
}: {
  id: number;
  province: number;
  commune: number;
  addr: string;
  branchId: number;
  deleteViewStatus: any;
  deliveryStatus: number;
  typeAddr: number;
}) => {
  const [branchToAddress, setBranchToAddress] = useState<number>(
    typeAddr === 1 ? branchId : 0
  );
  const [provinceId, setProvinceId] = useState<any>(province);
  const [communeId, setCommuneId] = useState<any>(commune);
  const [address, setAddress] = useState<any>(addr);
  const [type, setType] = useState<number>(0);
  const [transport, setTransport] = useState<number | null>(0);

  const [dataBranchSelect, setDataBranchSelect] = useState<TblDmMasterOrg[]>(
    []
  );
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataTransports, setDataTransports] = useState<tblDmTransportsModel[]>(
    []
  );

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgAll();

    if (res) {
      setDataBranchSelect(res);

      if (typeAddr === 1) {
        const dataProps = res.find((i) => String(i.id) === String(branchId));

        if (dataProps) {
          setProvinceId(dataProps.attribute8);
          setCommuneId(dataProps.attribute9);
          setAddress(dataProps.attribute10);
        }
      }
    }
  };

  const getDataProvinceSelect = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      const data = res
        ?.filter((item) => item.id && item.name)
        ?.map((item) => ({
          value: String(item.id),
          label: String(item.name),
        }));
      setDataProvinceSelect(data);
    }
  };

  const getDataCommuneSelect = async (id: string) => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?Active=true&ProvinceIds=${id}`
    );

    if (res && res.success) {
      const result = res.data;
      setDataCommuneSelect(
        result
          ?.filter((item: any) => item.text && item.value)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          }))
      );
    }
  };

  const getDataTransport = async () => {
    const data = await repositoryDelivery.get<
      MessageResponse<tblDmTransportsModel[]>
    >(`api/v1/TblDmTransports/get-all`);
    if (data?.success) {
      const res = data?.data.filter(
        (i) => i.fromBranchId?.toString() === branchId.toString()
      );
      setDataTransports(res);
    }
  };

  const changeLocation = async () => {
    const toBranchIdType2 =
      type === 2 && transport && dataTransports.length > 0
        ? Number(
            dataTransports.find((i) => String(i.id) === String(transport))
              ?.toBranchId
          )
        : 0;

    const res = await repositoryDelivery.post(
      "/api/v1/TblDelivery/update-to-address-v3",
      {
        id: id,
        provinceId:
          type === 2 && typeAddr === 2
            ? dataBranchSelect.find(
                (i) => String(i.id) === String(toBranchIdType2)
              )?.attribute8
            : provinceId,
        districtId: null,
        communeId:
          type === 2 && typeAddr === 2
            ? dataBranchSelect.find(
                (i) => String(i.id) === String(toBranchIdType2)
              )?.attribute9
            : communeId,
        streetId: null,
        addressDetail:
          type === 2 && typeAddr === 2
            ? dataBranchSelect.find(
                (i) => String(i.id) === String(toBranchIdType2)
              )?.attribute10
            : address,
        toAddress:
          type === 2 && typeAddr === 2
            ? dataTransports.find((i) => String(i.id) === String(transport))
                ?.transportAddress
            : [
                address,
                getValueById(String(communeId), dataCommuneSelect, "label"),
                getValueById(String(provinceId), dataProvinceSelect, "label"),
              ]
                .filter((i) => i && i.length > 0)
                .join(" - "),
        isAll: deliveryStatus === 9 ? true : false,
        branchId:
          type === 2 && typeAddr === 2 ? toBranchIdType2 : branchToAddress,
        distance:
          type === 2 && typeAddr === 2
            ? Number(
                dataTransports.find((i) => String(i.id) === String(transport))
                  ?.distance
              )
            : 0,
        typeAddr: typeAddr,
        transportId: type === 2 && typeAddr === 2 ? transport : 0,
        type: type === 0 ? "TH" : type === 1 ? "CN" : "NX",
      }
    );
    if (res && res?.success) {
      if (typeAddr === 1) {
        NotificationExtension.Success("Đã thay đổi điểm đi !");
      } else NotificationExtension.Success("Đã thay đổi điểm đến !");
      setTimeout(() => {
        modals.closeAll();
        deleteViewStatus((prev: any) => !prev);
      }, 1000);
    }
  };

  useEffect(() => {
    getDataBranchSelect();
    getDataProvinceSelect();
  }, []);

  useEffect(() => {
    if (typeAddr === 2) {
      getDataTransport();
    }
  }, [typeAddr]);

  useEffect(() => {
    if (branchToAddress || type === 1) {
      const dataProps = dataBranchSelect.find(
        (i) => String(i.id) === String(branchToAddress)
      );

      if (dataProps) {
        setProvinceId(dataProps.attribute8);
        setCommuneId(dataProps.attribute9);
        setAddress(dataProps.attribute10);
      }
    }
  }, [branchToAddress, type]);

  useEffect(() => {
    if (provinceId) {
      getDataCommuneSelect(String(provinceId));
    }
  }, [provinceId]);

  return (
    <Box w={450}>
      {(deliveryStatus === 9 || deliveryStatus === 1) && typeAddr === 1 ? (
        <Fieldset legend="Điểm đi" mt={10}>
          <Grid>
            <Grid.Col span={12}>
              <Grid>
                <Grid.Col span={12}>
                  <Select
                    label="Chi nhánh"
                    placeholder="Chọn chi nhánh"
                    data={dataBranchSelect
                      ?.filter((i) => i.id && i.code && i.name)
                      ?.map((i) => ({
                        label: `${i.code} - ${i.name}`,
                        value: String(i.id),
                      }))}
                    value={branchToAddress ? branchToAddress?.toString() : null}
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    onChange={(e) => setBranchToAddress(e ? Number(e) : 0)}
                  />
                </Grid.Col>
              </Grid>
              <Divider my="xs" label="Địa chỉ chi tiết" labelPosition="left" />
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Select
                    label="Tỉnh/TP"
                    placeholder="Nhập tỉnh/thành phố"
                    data={dataProvinceSelect}
                    value={provinceId ? provinceId?.toString() : null}
                    disabled={!branchToAddress}
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    withAsterisk
                    onChange={(e) => {
                      setProvinceId(e);
                      setCommuneId(null);
                      setAddress("");

                      if (e && e.length > 0) {
                        getCommuneSelect(e);
                      }
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Select
                    label="Phường/Xã"
                    placeholder="Nhập phường/xã"
                    data={dataCommuneSelect}
                    value={communeId ? communeId?.toString() : null}
                    disabled={
                      !provinceId ||
                      String(provinceId).length === 0 ||
                      !branchToAddress
                    }
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    withAsterisk
                    onChange={(e) => {
                      setCommuneId(e);
                      setAddress("");

                      if (e && e.length > 0) {
                        getCommuneSelect(e);
                      }
                    }}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Địa chỉ cụ thể"
                    description="Không bao gồm tỉnh/TP, phường/xã"
                    placeholder="Nhập địa chỉ cụ thể"
                    disabled={
                      !provinceId ||
                      String(provinceId).length === 0 ||
                      !communeId ||
                      String(communeId).length === 0 ||
                      !branchToAddress
                    }
                    value={address}
                    onChange={(e) => setAddress(e.currentTarget.value)}
                  />
                </Grid.Col>
              </Grid>
            </Grid.Col>
          </Grid>
        </Fieldset>
      ) : (
        <>
          <Grid mt={20}>
            <Grid.Col span={12}>
              <Select
                label="Loại điểm đến"
                placeholder="Chọn loại điểm đến"
                data={[
                  {
                    value: "0",
                    label: "Thường",
                  },
                  { value: "1", label: "Chi nhánh" },
                  { value: "2", label: "Nhà xe" },
                ]}
                value={String(type)}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                onChange={(e) => setType(e ? Number(e) : 0)}
              />
            </Grid.Col>
          </Grid>
          <Fieldset legend="Điểm đến">
            {type !== 2 ? (
              <>
                {type === 1 ? (
                  <Grid>
                    <Grid.Col span={12}>
                      <Select
                        label="Chi nhánh"
                        placeholder="Chọn chi nhánh"
                        data={dataBranchSelect
                          ?.filter((i) => i.id && i.code && i.name)
                          ?.map((i) => ({
                            label: `${i.code} - ${i.name}`,
                            value: String(i.id),
                          }))}
                        value={
                          branchToAddress ? branchToAddress?.toString() : null
                        }
                        searchable
                        clearable
                        nothingFoundMessage="Không tìm thấy dữ liệu !"
                        onChange={(e) => setBranchToAddress(e ? Number(e) : 0)}
                      />
                    </Grid.Col>
                  </Grid>
                ) : (
                  <></>
                )}
                <Grid>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <Select
                      label="Tỉnh/TP"
                      placeholder="Nhập tỉnh/thành phố"
                      data={dataProvinceSelect}
                      value={provinceId ? provinceId?.toString() : null}
                      disabled={!branchToAddress && type === 1}
                      searchable
                      clearable
                      nothingFoundMessage="Không tìm thấy dữ liệu !"
                      withAsterisk
                      onChange={(e) => {
                        setProvinceId(e);
                        setCommuneId(null);
                        setAddress("");

                        if (e && e.length > 0) {
                          getCommuneSelect(e);
                        }
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <Select
                      label="Phường/Xã"
                      placeholder="Nhập phường/xã"
                      data={dataCommuneSelect}
                      value={communeId ? communeId?.toString() : null}
                      disabled={
                        (!provinceId ||
                          String(provinceId).length === 0 ||
                          !branchToAddress) &&
                        type === 1
                      }
                      searchable
                      clearable
                      nothingFoundMessage="Không tìm thấy dữ liệu !"
                      withAsterisk
                      onChange={(e) => {
                        setCommuneId(e);
                        setAddress("");

                        if (e && e.length > 0) {
                          getCommuneSelect(e);
                        }
                      }}
                    />
                  </Grid.Col>
                </Grid>
                <Grid>
                  <Grid.Col span={12}>
                    <TextInput
                      label="Địa chỉ cụ thể"
                      description="Không bao gồm tỉnh/TP, phường/xã"
                      placeholder="Nhập địa chỉ cụ thể"
                      disabled={
                        (!provinceId ||
                          String(provinceId).length === 0 ||
                          !communeId ||
                          String(communeId).length === 0 ||
                          !branchToAddress) &&
                        type === 1
                      }
                      value={address}
                      onChange={(e) => setAddress(e.currentTarget.value)}
                    />
                  </Grid.Col>
                </Grid>
              </>
            ) : (
              <>
                <Grid>
                  <Grid.Col span={12}>
                    <Select
                      label="Tên nhà xe"
                      placeholder="Chọn nhà xe"
                      data={dataTransports?.map((item: any) => ({
                        value: item.id.toString(),
                        label: `${item.transportName} [${item.attribute2}]`,
                      }))}
                      value={transport ? String(transport) : null}
                      searchable
                      clearable
                      nothingFoundMessage={
                        dataTransports.length === 0
                          ? "Không có nhà xe chuyển giao cho chi nhánh này !"
                          : "Không tìm thấy dữ liệu !"
                      }
                      onChange={(e) => {
                        setTransport(e ? Number(e) : null);
                      }}
                    />
                  </Grid.Col>
                </Grid>
                <Grid>
                  <Grid.Col span={12}>
                    <TextInput
                      label="Địa chỉ nhà xe"
                      placeholder="Địa chỉ nhà xe"
                      value={
                        transport && dataTransports && dataTransports.length > 0
                          ? dataTransports.find(
                              (i) => String(i.id) === String(transport)
                            )?.transportAddress ?? ""
                          : ""
                      }
                      variant="filled"
                      readOnly
                    />
                  </Grid.Col>
                </Grid>
                <Grid>
                  <Grid.Col span={12}>
                    <TextInput
                      label="Quãng đường (Số km)"
                      placeholder="Quãng đường (Số km)"
                      value={
                        transport && dataTransports && dataTransports.length > 0
                          ? `${
                              dataTransports.find(
                                (i) => String(i.id) === String(transport)
                              )?.distance ?? ""
                            } km`
                          : ""
                      }
                      variant="filled"
                      readOnly
                    />
                  </Grid.Col>
                </Grid>
              </>
            )}
          </Fieldset>
        </>
      )}

      <Flex justify={"end"} gap={"md"} mt={10}>
        <Button
          variant="outline"
          color="green"
          leftSection={<IconCheck size={14} />}
          onClick={() => changeLocation()}
          disabled={
            !provinceId ||
            provinceId === "" ||
            !communeId ||
            communeId === "" ||
            (!branchToAddress && type === 1) ||
            (type === 2 && !transport)
          }
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default ChangeLocationV2;
